<div class="snackbar-container">
    <img height="21" width="21" style="margin-left: 21.33px;" src="../../../assets/Alert_box/success_tick.svg">
    <span>{{data.successMessage}}</span>
    <img class="close-snackbar" (click)="snackbarRef.dismiss()" src="../../../assets/Alert_box/close_icon.svg">
</div>